import React from 'react'
import * as Styled from './ListChart.styled'
import { NoDataMessage } from '../ChartPlaceholder'

type Props = {
  data?: { count: number; name: string }[]
  style?: React.CSSProperties
}

const ListChart: React.FC<Props> = ({ data, style }) =>
  data?.length ? (
    <Styled.List style={style}>
      {data.map(({ count, name }, index, array) => {
        const maxCount = Math.max(...array.map(value => value.count))
        const progressPercentage = (count / maxCount) * 90

        return (
          <Styled.Element key={index} progress={progressPercentage}>
            <Styled.Marker>{index + 1}</Styled.Marker>
            <Styled.Label>{name}</Styled.Label>
          </Styled.Element>
        )
      })}
    </Styled.List>
  ) : (
    <>
      <Styled.List isEmpty>
        {Array(10)
          .fill(0)
          .map((_, index) => (
            <Styled.Element key={index} progress={0}>
              <Styled.Marker>{index + 1}</Styled.Marker>
              <Styled.Placeholder />
            </Styled.Element>
          ))}
        <NoDataMessage />
      </Styled.List>
    </>
  )

export default ListChart
